import { gql } from 'graphql-tag'
import queryPageFields from '../../../core/data-layer/pages/page/query-page-fields'
import { fragmentModuleMedia, fragmentModuleUsp } from '../../../core/data-layer/modules/fragments'
import {
  fragmentBlockFaqGroup,
  fragmentBlockCallToAction,
  fragmentBlockHighlight
} from '../../../core/data-layer/blocks/fragments'

export default gql`
    ${fragmentModuleMedia}
    ${fragmentModuleUsp}
    ${fragmentBlockFaqGroup}
    ${fragmentBlockCallToAction}
    ${fragmentBlockHighlight}
    query($slug: String!, $locale: String!, $preview: Boolean!) {
        page: pagePaymentMethodsCollection(limit: 1, where: { slug: $slug }, locale: $locale, preview: $preview) {
            items {
                ${queryPageFields}
                subtitle
                paymentMethodsButtonText
                uspsCollection(limit: 4) {
                    items {
                        ...ModuleUspFragment
                    }
                }
                highlight {
                    ...BlockHighlightFragment
                }
                regionsGalleryTitle
                regionsGalleryText
                faq {
                    ...BlockFaqGroupFragment
                }
                callToAction {
                    ...BlockCallToActionFragment
                }
                paymentMethodsCollection(limit: 16) {
                    items {
                        sys {
                            id
                        }
                    }
                }
            }
        }
        pagePaymentMethodsDetail: pagePaymentMethodsDetailCollection(limit: 100, locale: $locale, preview: $preview) {
            items {
                sys {
                    id
                }
                paymentMethod {
                    sys {
                        id
                    }
                }
            }
        }
        pagePaymentMethodsGuidesRegion: pagePaymentMethodsGuidesRegionCollection(limit: 10, locale: $locale, preview: $preview) {
            items {
                sys {
                    id
                }
                image {
                    ...ModuleMediaFragment
                }
                region {
                    sys {
                        id
                    }
                    name
                }
            }
        }
        pagePaymentMethodsGuidesRegionCountry: pagePaymentMethodsGuidesRegionCountryCollection(limit: 80, locale: $locale, preview: $preview) {
            items {
                sys {
                    id
                }
                shortDescription
                image {
                    ...ModuleMediaFragment
                }
                country {
                    sys {
                        id
                    }
                    name
                }
            }
        }
    }
`
